import React from "react";
import { Trans, useTranslation } from "react-i18next";

import DPCard from "../../../../../../packages/DPCard";
import WPHeading from "../../../../../../packages/WPHeading";

import { LICENSE_SUPPORT_URL } from "../UserLicenseDetails.constants";

import "./UserLicenseSupport.scss";

const UserLicenseSupport = () => {
  useTranslation();

  return (
    <DPCard className="user-license-support-container">
      <div
        className="user-license-header-conatiner"
        id="user-license-support-title"
      >
        <WPHeading size="small" type="default" secondary fontNoto>
          <Trans
            i18nKey="licenseProfile.licenseSupport"
            components={{
              hyperLink: (
                // eslint-disable-next-line jsx-a11y/anchor-has-content
                <a
                  href={LICENSE_SUPPORT_URL}
                  target="_blank"
                  rel="noreferrer"
                />
              ),
            }}
          />
        </WPHeading>
      </div>
    </DPCard>
  );
};

export default UserLicenseSupport;
